import { render, staticRenderFns } from "./ProductRelatedBed.vue?vue&type=template&id=f7fd1514&scoped=true&"
import script from "./ProductRelatedBed.vue?vue&type=script&lang=js&"
export * from "./ProductRelatedBed.vue?vue&type=script&lang=js&"
import style0 from "./ProductRelatedBed.vue?vue&type=style&index=0&id=f7fd1514&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7fd1514",
  null
  
)

export default component.exports